<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
            {{ $t("navigations.create shell") }}
        </template>

        <template #body>
            <div class="modal-scroll-body">
            <div class="row">

                <!-- ── SHELL DETAILS ── -->
                <div class="col-md-12">
                    <div class="section-card">
                        <div class="section-title">SHELL DETAILS</div>
                        <div class="row g-2">
                            <!-- Shell Name -->
                            <div class="col-md-6 form-group mb-0">
                                <label class="form-label-sm">
                                    Shell Name
                                    <sup><i class="fa fa-asterisk required"></i></sup>
                                </label>
                                <input v-model="newShell.shellName" class="form-control form-control-sm" :disabled="isEditMode" type="text" />
                                <span v-if="errors.shellName" class="errormsg ml-0">{{ errorMessages.shellName }}</span>
                            </div>
                            <!-- Shell Version -->
                            <div class="col-md-6 form-group mb-0">
                                <label class="form-label-sm">
                                    Shell Version
                                    <sup><i class="fa fa-asterisk required"></i></sup>
                                </label>
                                <input v-model="newShell.shellVersion" class="form-control form-control-sm" :disabled ="isEditMode" type="text"  />
                                <span v-if="errors.shellVersion" class="errormsg ml-0">{{ errorMessages.shellVersion }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── FONT SETTINGS ── -->
                <div class="col-md-12">
                    <div class="section-card">
                        <div class="section-title">FONT SETTINGS</div>
                        <div class="row g-2">
                            <!-- Font Family -->
                            <div class="col-md-6 form-group mb-0">
                                <label class="form-label-sm">Font Family</label>
                                <select v-model="newShell.fontFamily" class="form-select form-select-sm">
                                    <option value="">Select</option>
                                    <option value="Monospace">Monospace</option>
                                    <option value="Arial">Arial</option>
                                    <option value="Times New Roman">Times New Roman</option>
                                    <option value="Courier New">Courier New</option>
                                    <option value="Helvetica">Helvetica</option>
                                </select>
                            </div>
                            <!-- Font Size -->
                            <div class="col-md-6 form-group mb-0">
                                <label class="form-label-sm">Font Size (pt)</label>
                                <input v-model.number="newShell.fontSize" class="form-control form-control-sm" type="number" min="0" max="72" placeholder="Enter font size" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── PAGE LAYOUT ── -->
                <div class="col-md-12">
                    <div class="section-card">
                        <div class="section-title">PAGE LAYOUT- Margin (mm)</div>
                        <div class="row g-2">
                            <div class="col-md-3 form-group mb-0">
                                <label class="form-label-sm">Top</label>
                                <input v-model.number="newShell.marginTop" class="form-control form-control-sm" type="number" min="0" placeholder="Enter margin top" />
                            </div>
                            <div class="col-md-3 form-group mb-0">
                                <label class="form-label-sm">Bottom</label>
                                <input v-model.number="newShell.marginBottom" class="form-control form-control-sm" type="number" min="0" placeholder="Enter margin bottom" />
                            </div>
                            <div class="col-md-3 form-group mb-0">
                                <label class="form-label-sm">Left</label>
                                <input v-model.number="newShell.marginLeft" class="form-control form-control-sm" type="number" min="0" placeholder="Enter margin left" />
                            </div>
                            <div class="col-md-3 form-group mb-0">
                                <label class="form-label-sm"> Right</label>
                                <input v-model.number="newShell.marginRight" class="form-control form-control-sm" type="number" min="0" placeholder="Enter margin right" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── HEADER / TITLE / FOOTER ── -->
                <div class="col-md-12">
                    <div class="section-card">

                        <!-- HEADER -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-bold small" style="font-size:11px; color:#145faf;">HEADER</span>
                            <div class="d-flex gap-1 align-items-center">
                                <label class="mb-0 me-1 small d-flex align-items-center gap-1" style="font-size:11px;">
                                    <input type="checkbox" v-model="headerBorderBottom" /> Border Bottom
                                </label>
                                <div class="position-relative align-self-center" aria-label="Add Header Row" tabindex="0">
                                <button class="btn btn-primary btn-xs cursor-pointer"
                                src="../../assets/img/create.png"
                                width="17"
                                height="17"
                                alt="Add Row" @click="addHeaderRow" :disabled="headerRows.length >= maxHeaderRows" title="Add header row">
                                <i class="fa fa-plus"></i>
                                </button>
                                 <div class="tool-tip mt-2">Add Row</div>
                                </div>
                                <div class="position-relative align-self-center" aria-label="Remove Header Row" tabindex="0">
                                <button class="btn btn-danger btn-xs cursor-pointer" src="../../assets/img/create.png"
                                width="17"
                                height="17" 
                                alt="Remove Row"
                                @click="removeHeaderRow" :disabled="headerRows.length <= 1" title="Remove header row">
                                    <i class="fa fa-minus"></i>
                                </button>
                                 <div class="tool-tip mt-2">Remove Row</div>
                                 </div>
                            </div>
                        </div>

                        <div v-for="(row, index) in headerRows" :key="'header-' + index" class="row g-1 mb-1">
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Left</label>
                                <select class="form-select form-select-sm" v-model="row.left">
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Center</label>
                                <select class="form-select form-select-sm" v-model="row.center">
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Right</label>
                                <select class="form-select form-select-sm" v-model="row.right">
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                        </div>

                        <hr class="my-2" />

                        <!-- TITLE -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-bold small" style="font-size:11px; color:#145faf;">TITLE</span>
                        </div>
                        <div class="row g-1 mb-1 align-items-end">
                            <div class="col-md-6 form-group mb-0">
                                <label class="form-label-sm">Title Text</label>
                                <select class="form-select form-select-sm" v-model="newShell.titleText">
                                    <option value="">-- Select Field --</option>
                                    <option v-for="item in titleTokenOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
                                </select>
                            </div>
                        <div class="col-md-6 d-flex align-items-end gap-3 small pb-1" style="font-size:11px;">
                         <label class="mb-0 d-flex align-items-center gap-1"><input type="checkbox" v-model="newShell.titleBold" /> Bold</label>
                         <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="modal-align" value="left"   v-model="newShell.titleAlign" /> Left</label>
                         <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="modal-align" value="center" v-model="newShell.titleAlign" /> Center</label>
                         <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="modal-align" value="right"  v-model="newShell.titleAlign" /> Right</label>
                        </div>
                        </div>

                        <hr class="my-2" />

                        <!-- FOOTER -->
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-bold small" style="font-size:11px; color:#145faf;">FOOTER</span>
                            <div class="d-flex gap-1 align-items-center">
                                <label class="mb-0 me-1 small d-flex align-items-center gap-1" style="font-size:11px;">
                                    <input type="checkbox" v-model="footerBorderTop" /> Border Top
                                </label>
                                <div class="position-relative align-self-center" aria-label="addFooterRow" tabindex="0">
                                <button class="btn btn-primary btn-xs cursor-pointer" src="../../assets/img/create.png"
                                width="17"
                                height="17"
                                alt="Add Row"  @click="addFooterRow" :disabled="footerRows.length >= maxFooterRows" title="Add footer row">
                                <i class="fa fa-plus"></i>
                                </button>
                                 <div class="tool-tip mt-2">Add Row</div>
                                </div>
                                <div class="position-relative align-self-center" aria-label="removeFooterRow" tabindex="0">
                                <button class="btn btn-danger btn-xs cursor-pointer" src="../../assets/img/create.png"
                                width="17"
                                height="17"
                                alt="Remove Row"  @click="removeFooterRow" :disabled="footerRows.length <= 1" title="Remove footer row">
                                <i class="fa fa-minus"></i>
                                </button>
                               <div class="tool-tip mt-2">Remove Row</div>
                                </div>
                            </div>
                        </div>

                        <div v-for="(row, index) in footerRows" :key="'footer-' + index" class="row g-1 mb-1">
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Left</label>
                                <select class="form-select form-select-sm" v-model="row.left">
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Center</label>
                                <select
                                    class="form-select form-select-sm"
                                    v-model="row.center"
                                    :disabled="isFootnoteSelected(row)"
                                    @change="handleFooterSelection(row, 'center')"
                                >
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group mb-0">
                                <label class="form-label-sm">Right</label>
                                <select
                                    class="form-select form-select-sm"
                                    v-model="row.right"
                                    :disabled="isFootnoteSelected(row)"
                                    @change="handleFooterSelection(row, 'right')"
                                >
                                    <option value="">-- Select Field --</option>
                                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                </select>
                            </div>
                        </div>

                        <hr class="my-2" />

                        <!-- Submit -->
                        <div class="d-flex justify-content-end gap-2 mt-1">
                            <button class="btn btn-primary px-2 py-0 btn-sm" @click="submitShell">
                                {{ isEditMode ? 'Update' : 'Create' }}
                            </button>
                        </div>

                    </div>
                </div>

            </div>
            </div>
        </template>
    </customModal>
</template>

<script src="../shells/ShellModal.js"></script>

<style scoped>
/* Scroll container — vertical only, no horizontal bleed */
.modal-scroll-body {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}
/* Neutralise Bootstrap row's negative margins inside the scroll container */
.modal-scroll-body > .row {
    margin-left: 0;
    margin-right: 0;
}
/* Section card — matches ShellEdit */
.section-card {
    background: #f8f9fa;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    padding: 9px 10px;
    margin-bottom: 8px;
}
.section-title {
    font-size: 11px;
    font-weight: 700;
    color: #145faf;
    text-transform: none;
    letter-spacing: 0.3px;
    margin-bottom: 6px;
    justify-content: start;
}

/* Small labels */
.form-label-sm {
    font-size: 11px;
    margin-bottom: 2px;
    display: block;
    color: #444;
}
input[type="checkbox"] {
    margin: 0;
    transform: translateY(-1px);
}

/* Inputs / selects */
.form-control-sm,
.form-select-sm {
    font-size: 12px !important;
    padding: 3px 6px !important;
    height: 28px !important;
}

.form-select { border-radius: 0 !important; }
.form-select:focus { border-color: #145faf !important; box-shadow: none !important; }
.form-group { margin-bottom: 0 !important; }

.btn-xs {
    padding: 2px 6px;
    font-size: 11px;
    line-height: 1;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-xs i { font-size: 10px; }
</style>
